import Default from "../Pages/Dashboard/Default/Default";
import EcommerceDashborad from "../Pages/Dashboard/Ecommerce/EcommerceDashborad";
import EducationDashboard from "../Pages/Dashboard/Education/EducationDashboard";
import ProjectDashboard from "../Pages/Dashboard/ProjectDashboard/ProjectDashboard";
import Grid from "../Pages/Ui-Kits/Grid";
import HelperClasses from "../Pages/Ui-Kits/HelperClasses";
import Avatars from "../Pages/Ui-Kits/Avatars";
import Typography from "../Pages/Ui-Kits/Typography";
import HideNavScrollContainer from "../Pages/PageLayout/HideNavScrollContainer/HideNavScrollContainer";
import Charts from "../Pages/Widgets/Charts/Charts";
import General from "../Pages/Widgets/General/General";
import Timeline from "../Pages/BonusUi/Timeline/Timeline";
import BasicCard from "../Pages/BonusUi/BasicCard/BasicCard";
import CreativeCard from "../Pages/BonusUi/CreativeCard/CreativeCard";
import RangeSlider from "../Pages/BonusUi/RangeSlider/RangeSlider";
import ImageCropper from "../Pages/BonusUi/ImageCropper/ImageCropper";
import OwlCarousel from "../Pages/BonusUi/OwlCarousel/OwlCarousel";
import Breadcrumb from "../Pages/BonusUi/Breadcrumb/Breadcrumb";
import Tour from "../Pages/BonusUi/Tour/Tour";
import Ribbons from "../Pages/BonusUi/Ribbons/Ribbons";
import Dropzone from "../Pages/BonusUi/Dropzone/Dropzone";
import SweetAlert from "../Pages/BonusUi/SweetAlert/SweetAlert";
import Paginations from "../Pages/BonusUi/Paginations/Paginations";
import Toast from "../Pages/BonusUi/Toast/Toast";
import Rating from "../Pages/BonusUi/Rating/Rating";
import Scrollable from "../Pages/BonusUi/Scrollable/Scrollable";
import TreeView from "../Pages/BonusUi/TreeView/TreeView";
import Lists from "../Pages/Ui-Kits/Lists";
import Accordion from "../Pages/Ui-Kits/Accordion";
import BootstrapTabs from "../Pages/Ui-Kits/BootstrapTabs";
import Dropdown from "../Pages/Ui-Kits/Dropdown";
import Alert from "../Pages/Ui-Kits/Alert";
import Popover from "../Pages/Ui-Kits/Popover";
import Tooltip from "../Pages/Ui-Kits/Tooltip";
import Modal from "../Pages/Ui-Kits/Modal";
import TagAndPills from "../Pages/Ui-Kits/TagAndPills";
import Progress from "../Pages/Ui-Kits/Progress";
import BasicTable from "../Pages/Tables/ReactstrapTable/BasicTable/BasicTable";
import TableComponent from "../Pages/Tables/ReactstrapTable/TableComponent/TableComponent";
import TwoFactor from "../Pages/Forms/FormsLayout/TwoFactor/TwoFactor";
import FormWizardTwo from "../Pages/Forms/FormsLayout/FormWizardTwo/FormWizardTwo";
import FormWizardOne from "../Pages/Forms/FormsLayout/FormWizardOne/FormWizardOne";
import Switch from "../Pages/Forms/FormsWidgets/Switch/Switch";
import Typeahead from "../Pages/Forms/FormsWidgets/Typeahead/Typeahead";
import ClipBoard from "../Pages/Forms/FormsWidgets/ClipBoard/ClipBoard";
import DatePicker from "../Pages/Forms/FormsWidgets/DatePicker/DatePicker";
import TouchSpin from "../Pages/Forms/FormsWidgets/TouchSpin/TouchSpin";
import MegaOption from "../Pages/Forms/FormsControl/MegaOption/MegaOption";
import InputGroup from "../Pages/Forms/FormsControl/InputGroup/InputGroup";
import InputMask from "../Pages/Forms/FormsControl/InputMask/InputMask";
import RadioCheckbox from "../Pages/Forms/FormsControl/RadioCheckbox/RadioCheckbox";
import FormsValidation from "../Pages/Forms/FormsControl/FormsValidation/FormsValidation";
import BaseInput from "../Pages/Forms/FormsControl/BaseInput/BaseInput";
import ApexChart from "../Pages/Charts/Apexchart/ApexChart";
import GoogleChart from "../Pages/Charts/GoogleChart/GoogleChart";
import ChartJs from "../Pages/Charts/ChartJs/ChartJs";
import DefaultStyle from "../Pages/Buttons/DefaultStyle/DefaultStyle";
import FlatStyle from "../Pages/Buttons/FlatStyle/FlatStyle";
import EdgeStyle from "../Pages/Buttons/EdgeStyle/EdgeStyle";
import RaisedStyle from "../Pages/Buttons/RaisedStyle/RaisedStyle";
import ButtonGroup from "../Pages/Buttons/ButtonGroup/ButtonGroup";
import FlagIcons from "../Pages/Icons/FlagIcons";
import FontAwesomeIcon from "../Pages/Icons/FontAwesomeIcon";
import ICOIcon from "../Pages/Icons/ICOIcon";
import ThemifyIcons from "../Pages/Icons/ThemifyIcons";
import FeatherIcons from "../Pages/Icons/FeatherIcons";
import WhetherIcon from "../Pages/Icons/WhetherIcons";
import Bookmark from "../Pages/Application/Bookmark/Bookmark";
import Todo from "../Pages/Application/Todo/Todo";
import SearchResult from "../Pages/Application/SearchResult/SearchResult";
import FileManager from "../Pages/Application/FileManager/FileManager";
import Calender from "../Pages/Application/Calender/Calender";
import ProjectList from "../Pages/Application/Project/ProjectList/ProjectList";
import ProjectCreate from "../Pages/Application/Project/ProjectCreate/ProjectCreate";
import SamplePage from "../Pages/SamplePage/SamplePage";
import GoogleMap from "../Pages/Miscellaneous/Maps/GoogleMap/GoogleMap";
import LeafletMaps from "../Pages/Miscellaneous/Maps/LeafletMaps/LeafletMaps";
import CkEditor from "../Pages/Miscellaneous/Editor/CkEditor/CkEditor";
import MdeEditor from "../Pages/Miscellaneous/Editor/MdeEditor/MdeEditor";
import AceEditor from "../Pages/Miscellaneous/Editor/AceEditor/AceEditor";
import SupportTicket from "../Pages/Miscellaneous/SupportTicket/SupportTicket";
import Faq from "../Pages/Miscellaneous/Faq/Faq";
import Knowledgebase from "../Pages/Miscellaneous/Knowledgebase/Knowledgebase";
import BlogDetails from "../Pages/Miscellaneous/Blog/BlogDetails/BlogDetails";
import BlogSingle from "../Pages/Miscellaneous/Blog/BlogSingle/BlogSingle";
import AddPost from "../Pages/Miscellaneous/Blog/AddPost/AddPost";
import GalleryGrid from "../Pages/Miscellaneous/Gallery/GalleryGrid/GalleryGrid";
import GalleryGridDesc from "../Pages/Miscellaneous/Gallery/GalleryGridDesc/GalleryGridDesc";
import MasonryGallery from "../Pages/Miscellaneous/Gallery/MasonryGallery/MasonryGallery";
import MasonryImageDesc from "../Pages/Miscellaneous/Gallery/MasonryImageDesc/MasonryImageDesc";
import HoverEffect from "../Pages/Miscellaneous/Gallery/HoverEffect/HoverEffect";
import BasicInit from "../Pages/Tables/DataTables/BasicInit/BasicInit";
import AdvanceInit from "../Pages/Tables/DataTables/AdvanceInit/AdvanceInit";
import ApiDataTable from "../Pages/Tables/DataTables/ApiDataTable/ApiDataTable";
import DataSource from "../Pages/Tables/DataTables/DataSource/DataSource";
import ProductPage from "../Pages/Application/Ecommerce/ProductPage/ProductPage";
import ProductList from "../Pages/Application/Ecommerce/ProductList/ProductList";
import PaymentDetails from "../Pages/Application/Ecommerce/PaymentDetails/PaymentDetails";
import WishList from "../Pages/Application/Ecommerce/WishList/WishList";
import Pricing from "../Pages/Application/Ecommerce/Pricing/Pricing";
import OrderHistory from "../Pages/Application/Ecommerce/OrderHistory/OrderHistory";
import PrivateChat from "../Pages/Application/Chat/PrivateChat/PrivateChat";
import GroupChat from "../Pages/Application/Chat/GroupChat/GroupChat";
import Contacts from "../Pages/Application/Contacts/Contacts";
import Tasks from "../Pages/Application/Tasks/Tasks";
import SocialApp from "../Pages/Application/SocialApp/SocialApp";
import UsersProfile from "../Pages/Application/Users/UsersProfile/UsersProfile";
import EditProfile from "../Pages/Application/Users/EditProfile/EditProfile";
import UserCards from "../Pages/Application/Users/UserCards/UserCards";
import Products from "../Pages/Application/Ecommerce/Products/Products";
import Cart from "../Pages/Application/Ecommerce/Cart/Cart";
import Checkout from "../Pages/Application/Ecommerce/Checkout/Checkout";
import LearningList from "../Pages/Miscellaneous/Learning/LearningList/LearningList";
import DetailsCourse from "../Pages/Miscellaneous/Learning/DetailsCourse/DetailsCourse";
import CardView from "../Pages/Miscellaneous/JobSearch/CardView/CardView";
import ListView from "../Pages/Miscellaneous/JobSearch/ListView/ListView";
import JobDetails from "../Pages/Miscellaneous/JobSearch/JobDetails/JobDetails";
import JobApply from "../Pages/Miscellaneous/JobSearch/JobApply/JobApply";
import AddProduct from "../Pages/Application/Ecommerce/AddProduct/AddProduct";
import InvoiceOne from "../Pages/Application/Ecommerce/Invoices/Invoice-1/Invoice-1";
import InvoiceTwo from "../Pages/Application/Ecommerce/Invoices/Invoice-2/Invoice-2";
import InvoiceThree from "../Pages/Application/Ecommerce/Invoices/Invoice-3/Invoice-3";
import InvoiceFour from "../Pages/Application/Ecommerce/Invoices/Invoice-4/Invoice-4";
import InvoiceFive from "../Pages/Application/Ecommerce/Invoices/Invoice-5/Invoice-5";
import InvoiceSix from "../Pages/Application/Ecommerce/Invoices/Invoice-6/Invoice-6";
import LetterBox from "../Pages/Application/LetterBox/LetterBox";


// YANG DI GUNAKAN
import SearchInput from "../Pages/Application/SearchInput/SearchResult";



const routes = [
  // dashboard 
  { path: `${process.env.PUBLIC_URL}/dashboard/default`, Component: <Default /> },
  { path: `${process.env.PUBLIC_URL}/dashboard/project`, Component:<ProjectDashboard />},
  { path: `${process.env.PUBLIC_URL}/dashboard/ecommerce`, Component: <EcommerceDashborad />},
  { path: `${process.env.PUBLIC_URL}/dashboard/education`, Component: <EducationDashboard />},

  // Widgets
  { path: `${process.env.PUBLIC_URL}/widgets/general`, Component:<General />},
  { path: `${process.env.PUBLIC_URL}/widgets/chart`, Component:<Charts />},

  // Page Layout
  { path: `${process.env.PUBLIC_URL}/page_layout/hide_nav_scroll`, Component: <HideNavScrollContainer />},

   // Project
   { path: `${process.env.PUBLIC_URL}/project/project_list`, Component: <ProjectList />},
   { path: `${process.env.PUBLIC_URL}/project/create_new`, Component: <ProjectCreate />},
   
   // File Manager
  { path: `${process.env.PUBLIC_URL}/app/file_manager`, Component: <FileManager />},

  // Ecommerce
  { path: `${process.env.PUBLIC_URL}/ecommerce/add_product`, Component: <AddProduct />},
  { path: `${process.env.PUBLIC_URL}/ecommerce/products`, Component: <Products />},
  { path: `${process.env.PUBLIC_URL}/ecommerce/product_page`, Component: <ProductPage />},
  { path: `${process.env.PUBLIC_URL}/ecommerce/product_list`, Component: <ProductList />},
  { path: `${process.env.PUBLIC_URL}/ecommerce/payment_details`, Component: <PaymentDetails />},
  { path: `${process.env.PUBLIC_URL}/ecommerce/order_history`, Component: <OrderHistory />},
    // Invoices
    { path: `${process.env.PUBLIC_URL}/ecommerce/invoice/invoice1`, Component: <InvoiceOne />},
    { path: `${process.env.PUBLIC_URL}/ecommerce/invoice/invoice2`, Component: <InvoiceTwo />},
    { path: `${process.env.PUBLIC_URL}/ecommerce/invoice/invoice3`, Component: <InvoiceThree />},
    { path: `${process.env.PUBLIC_URL}/ecommerce/invoice/invoice4`, Component: <InvoiceFour />},
    { path: `${process.env.PUBLIC_URL}/ecommerce/invoice/invoice5`, Component: <InvoiceFive />},
    { path: `${process.env.PUBLIC_URL}/ecommerce/invoice/invoice6`, Component: <InvoiceSix />},
  { path: `${process.env.PUBLIC_URL}/ecommerce/cart`, Component: <Cart />},
  { path: `${process.env.PUBLIC_URL}/ecommerce/wishlist`, Component: <WishList />},
  { path: `${process.env.PUBLIC_URL}/ecommerce/checkout`, Component: <Checkout />},
  { path: `${process.env.PUBLIC_URL}/ecommerce/pricing`, Component: <Pricing />},

  // LetterBox
  { path: `${process.env.PUBLIC_URL}/email/letter_box`, Component: <LetterBox />},

  // Chat
  { path: `${process.env.PUBLIC_URL}/chat/private_chat`, Component: <PrivateChat />},
  { path: `${process.env.PUBLIC_URL}/chat/group_chat`, Component: <GroupChat />},

  // Users
  { path: `${process.env.PUBLIC_URL}/users/user_profile`, Component: <UsersProfile />},
  { path: `${process.env.PUBLIC_URL}/users/user_edit`, Component: <EditProfile />},
  { path: `${process.env.PUBLIC_URL}/users/cards`, Component: <UserCards />},

  // Bookmark
  { path: `${process.env.PUBLIC_URL}/app/bookmark`, Component: <Bookmark />},

  // Contacts
  { path: `${process.env.PUBLIC_URL}/app/contacts`, Component: <Contacts />},

  // Tasks
  { path: `${process.env.PUBLIC_URL}/app/task`, Component: <Tasks />},

  // Calender
  { path: `${process.env.PUBLIC_URL}/app/calendar`, Component: <Calender />},

  // SocialApp
  { path: `${process.env.PUBLIC_URL}/app/social_app`, Component: <SocialApp />},

  // Todo
  { path: `${process.env.PUBLIC_URL}/app/todo`, Component: <Todo />},

  // SearchResult 
  { path: `${process.env.PUBLIC_URL}/app/search_result`, Component: <SearchResult />},

  // Forms Control
  { path: `${process.env.PUBLIC_URL}/forms/forms_controls/form_validation`, Component: <FormsValidation />},
  { path: `${process.env.PUBLIC_URL}/forms/forms_controls/base_input`, Component: <BaseInput />},
  { path: `${process.env.PUBLIC_URL}/forms/forms_controls/radio_checkbox`, Component: <RadioCheckbox />},
  { path: `${process.env.PUBLIC_URL}/forms/forms_controls/input_groups`, Component: <InputGroup />},
  { path: `${process.env.PUBLIC_URL}/forms/forms_controls/input_mask`, Component: <InputMask />},
  { path: `${process.env.PUBLIC_URL}/forms/forms_controls/mega_option`, Component: <MegaOption />},

  // Forms Widgets
  { path: `${process.env.PUBLIC_URL}/forms/forms_widget/datepicker`, Component: <DatePicker />},
  { path: `${process.env.PUBLIC_URL}/forms/forms_widget/touchspin`, Component: <TouchSpin />},
  { path: `${process.env.PUBLIC_URL}/forms/forms_widget/switch`, Component: <Switch />},
  { path: `${process.env.PUBLIC_URL}/forms/forms_widget/typeahead`, Component: <Typeahead />},
  { path: `${process.env.PUBLIC_URL}/forms/forms_widget/clipboard`, Component:<ClipBoard />},

  // Forms Layout
  { path: `${process.env.PUBLIC_URL}/forms/forms_layout/form_wizard_1`, Component: <FormWizardOne />},
  { path: `${process.env.PUBLIC_URL}/forms/forms_layout/form_wizard_2`, Component: <FormWizardTwo />},
  { path: `${process.env.PUBLIC_URL}/forms/forms_layout/two_factor`, Component: <TwoFactor />},

  // Tables
  { path: `${process.env.PUBLIC_URL}/table/reactstrap_table/basic_table`, Component: <BasicTable />},
  { path: `${process.env.PUBLIC_URL}/table/reactstrap_table/table_component`, Component: <TableComponent />},

  // Data Tables
  { path: `${process.env.PUBLIC_URL}/table/data_table/basic_init`, Component: <BasicInit />},
  { path: `${process.env.PUBLIC_URL}/table/data_table/advance_init`, Component: <AdvanceInit />},
  { path: `${process.env.PUBLIC_URL}/table/data_table/api`, Component: <ApiDataTable />},
  { path: `${process.env.PUBLIC_URL}/table/data_table/data_sources`, Component: <DataSource />},

  // Ui-kits
  { path: `${process.env.PUBLIC_URL}/uikits/typography`, Component: <Typography />},
  { path: `${process.env.PUBLIC_URL}/uikits/avatars`, Component:<Avatars />},
  { path: `${process.env.PUBLIC_URL}/uikits/helperclass`, Component:<HelperClasses />},
  { path: `${process.env.PUBLIC_URL}/uikits/grid`, Component:<Grid />},
  { path: `${process.env.PUBLIC_URL}/uikits/tagpills`, Component:<TagAndPills />},
  { path: `${process.env.PUBLIC_URL}/uikits/progress`, Component:<Progress />},
  { path: `${process.env.PUBLIC_URL}/uikits/modal`, Component:<Modal />},
  { path: `${process.env.PUBLIC_URL}/uikits/alert`, Component:<Alert />},
  { path: `${process.env.PUBLIC_URL}/uikits/popover`, Component:<Popover />},
  { path: `${process.env.PUBLIC_URL}/uikits/tooltip`, Component:<Tooltip />},
  { path: `${process.env.PUBLIC_URL}/uikits/dropdown`, Component:<Dropdown />},
  { path: `${process.env.PUBLIC_URL}/uikits/accordion`, Component:<Accordion />},
  { path: `${process.env.PUBLIC_URL}/uikits/tabs`, Component:<BootstrapTabs />},
  { path: `${process.env.PUBLIC_URL}/uikits/list`, Component:<Lists />},
  
  // Bonus-Ui
  { path: `${process.env.PUBLIC_URL}/bonusui/scrollable`, Component:<Scrollable />},
  { path: `${process.env.PUBLIC_URL}/bonusui/tree_view`, Component:<TreeView />},
  { path: `${process.env.PUBLIC_URL}/bonusui/toasts`, Component:<Toast />},
  { path: `${process.env.PUBLIC_URL}/bonusui/rating`, Component:<Rating />},
  { path: `${process.env.PUBLIC_URL}/bonusui/dropzone`, Component: <Dropzone />},
  { path: `${process.env.PUBLIC_URL}/bonusui/tour`, Component: <Tour />},
  { path: `${process.env.PUBLIC_URL}/bonusui/sweet_alert2`, Component: <SweetAlert />},
  { path: `${process.env.PUBLIC_URL}/bonusui/owl_carousel`, Component: <OwlCarousel />},
  { path: `${process.env.PUBLIC_URL}/bonusui/ribbons`, Component: <Ribbons />},
  { path: `${process.env.PUBLIC_URL}/bonusui/pagination`, Component: <Paginations />},
  { path: `${process.env.PUBLIC_URL}/bonusui/breadcrumb`, Component: <Breadcrumb />},
  { path: `${process.env.PUBLIC_URL}/bonusui/range_slider`, Component: <RangeSlider />},
  { path: `${process.env.PUBLIC_URL}/bonusui/image_cropper`, Component: <ImageCropper/>}, 
  { path: `${process.env.PUBLIC_URL}/bonusui/basic_cards`, Component: <BasicCard />},
  { path: `${process.env.PUBLIC_URL}/bonusui/creative_cards`, Component: <CreativeCard />},
  { path: `${process.env.PUBLIC_URL}/bonusui/timeline`, Component: <Timeline />},

  // Icons
  { path: `${process.env.PUBLIC_URL}/icons/flag_icons`, Component: <FlagIcons />},
  { path: `${process.env.PUBLIC_URL}/icons/fontawesome_icon`, Component: <FontAwesomeIcon />},
  { path: `${process.env.PUBLIC_URL}/icons/ico_icon`, Component: <ICOIcon />},
  { path: `${process.env.PUBLIC_URL}/icons/themify_icon`, Component: <ThemifyIcons />},
  { path: `${process.env.PUBLIC_URL}/icons/feather_icon`, Component: <FeatherIcons />},
  { path: `${process.env.PUBLIC_URL}/icons/weather_icon`, Component: <WhetherIcon />},

  // Buttons
  { path: `${process.env.PUBLIC_URL}/buttons/default_style`, Component: <DefaultStyle />},
  { path: `${process.env.PUBLIC_URL}/buttons/flat_style`, Component: <FlatStyle />},
  { path: `${process.env.PUBLIC_URL}/buttons/edge_style`, Component: <EdgeStyle />},
  { path: `${process.env.PUBLIC_URL}/buttons/raised_style`, Component: <RaisedStyle />},
  { path: `${process.env.PUBLIC_URL}/buttons/button_group`, Component: <ButtonGroup />},
  
  // Charts
  { path: `${process.env.PUBLIC_URL}/charts/apex_chart`, Component: <ApexChart />},
  { path: `${process.env.PUBLIC_URL}/charts/google_chart`, Component: <GoogleChart />},
  { path: `${process.env.PUBLIC_URL}/charts/chartjs_chart`, Component:<ChartJs />},

  // Pages
  { path: `${process.env.PUBLIC_URL}/pages/sample_page`, Component: <SamplePage />},

  // Gallery
  { path: `${process.env.PUBLIC_URL}/gallery/gallery_grids`, Component: <GalleryGrid />},
  { path: `${process.env.PUBLIC_URL}/gallery/gallery_grid_desc`, Component: <GalleryGridDesc />},
  { path: `${process.env.PUBLIC_URL}/gallery/masonry_gallery`, Component: <MasonryGallery />},
  { path: `${process.env.PUBLIC_URL}/gallery/masonry_with_desc`, Component: <MasonryImageDesc />},
  { path: `${process.env.PUBLIC_URL}/gallery/hover_effect`, Component: <HoverEffect />},

  // Blog
  { path: `${process.env.PUBLIC_URL}/blog/blog_details`, Component: <BlogDetails />},
  { path: `${process.env.PUBLIC_URL}/blog/blog_single`, Component: <BlogSingle />},
  { path: `${process.env.PUBLIC_URL}/blog/add_post`, Component: <AddPost />},
  
  // Faq
  { path: `${process.env.PUBLIC_URL}/fag/faq`, Component: <Faq />},
  
  // Job Search
  { path: `${process.env.PUBLIC_URL}/job_search/card_view`, Component:<CardView />},
  { path: `${process.env.PUBLIC_URL}/job_search/list_view`, Component: <ListView />},
  { path: `${process.env.PUBLIC_URL}/job_search/job_detail`, Component: <JobDetails />},
  { path: `${process.env.PUBLIC_URL}/job_search/apply`, Component: <JobApply />},

  // Learning
  { path: `${process.env.PUBLIC_URL}/learning/learning_list`, Component: <LearningList />},
  { path: `${process.env.PUBLIC_URL}/learning/learning_course`, Component: <DetailsCourse />},
  
  // Maps
  { path: `${process.env.PUBLIC_URL}/map/google_map`, Component: <GoogleMap />},
  { path: `${process.env.PUBLIC_URL}/map/leaflet_map`, Component: <LeafletMaps />},
  
  // Editor
  { path: `${process.env.PUBLIC_URL}/editor/ck_editor`, Component: <CkEditor />},
  { path: `${process.env.PUBLIC_URL}/editor/mde_editor`, Component: <MdeEditor />},
  { path: `${process.env.PUBLIC_URL}/editor/ace_editor`, Component: <AceEditor />},
  
  // Knowledgebase
  { path: `${process.env.PUBLIC_URL}/knowledgebase/knowledgebase`, Component: <Knowledgebase />},

  // Support Ticket
  { path: `${process.env.PUBLIC_URL}/support_ticket/support_ticket`, Component: <SupportTicket />},
  
  
  
  

  

  // Payment Details
  

  // WishList
  


// YANG DIGUNAKAN 
{ path: `${process.env.PUBLIC_URL}/app/insert_keyword`, Component: <SearchInput />},
  

 

 

  
  
  

 

  
  
 

  

]

export default routes;